import { html } from "lit";

export const template = (props) => html`
    <div class="container">
        <div id="rte">
        </div>
    </div>
`;
